import useActionsApplicationAdvancedForm from './useActionsApplicationAdvancedForm'

export default useActionsApplicationAdvancedForm
